import React from "react";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/marketingSagas";
import IntroRevenue from "./smartComponents/introRevenue";
import IntrosSold from "./smartComponents/introsSold";
import ProfilesCreated from "./smartComponents/profilesCreated";
import ProfilesToFirstVisit from "./smartComponents/profilesToFirstVisit";
import ReferralBySource from "./smartComponents/referralBySource";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { useSelector } from "react-redux";
import { useFetchData } from "../hooks/dataFetchingHooks";

const MarketingModule = (props) => {
  useFetchData({
    moduleName: "marketing",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  const isLoading = useSelector((state) => state.marketing.isLoading);
  const referralBySourceData = useSelector((state) => state.marketing.referralBySource);

  return (
    <SectionToggle
      title="Marketing"
      isLoading={isLoading}
      height={350}
      content={
        <div id="marketingModule">
          <div className="section-group">
            <div className="width-50" style={{ width: "50%", height: "140px" }}>
              <SectionContainer title="Intro Revenue">
                <IntroRevenue />
              </SectionContainer>
            </div>
            <div className="width-50" style={{ width: "50%", height: "140px" }}>
              <SectionContainer title="Intros Sold">
                <IntrosSold />
              </SectionContainer>
            </div>
            {referralBySourceData.length > 0 && (
              <div>
                <div className="width-50" style={{ width: "50%", height: "140px" }}>
                  <SectionContainer title="Profiles Created">
                    <ProfilesCreated />
                  </SectionContainer>
                </div>
                <div className="width-50" style={{ width: "50%", height: "140px" }}>
                  <SectionContainer title="Profiles to First Visit">
                    <ProfilesToFirstVisit />
                  </SectionContainer>
                </div>
              </div>
            )}
          </div>
          <div className="section-group">
            {referralBySourceData.length === 0 && (
              <div>
                <div className="width-50" style={{ width: "50%", height: "140px" }}>
                  <SectionContainer title="Profiles Created">
                    <ProfilesCreated />
                  </SectionContainer>
                </div>
                <div className="width-50" style={{ width: "50%", height: "140px" }}>
                  <SectionContainer title="Profiles to First Visit">
                    <ProfilesToFirstVisit />
                  </SectionContainer>
                </div>
              </div>
            )}
            {referralBySourceData.length > 0 && (
              <SectionContainer customStyles="padding-left" title="Referral By Source (Top 4)">
                <ReferralBySource />
              </SectionContainer>
            )}
          </div>
          <div className="clear-fix" />
        </div>
      }
    />
  );
};

export default MarketingModule;
